import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {useDispatch} from 'react-redux';
import {useRouter} from 'next/router';
import {useTranslations} from "use-intl";

import {useModal} from '@tager/web-components';
import {Option} from '@tager/web-core/src/typings/common';
import {QueryParams} from '@tager/web-core';

import {ReactComponent as SortIcon} from '@/assets/svg/Catalog/sort.svg';
import MultiSelect from '@/components/MultiSelect';
import {getOptions} from '@/constants/sort';
import useModalsOpen from '@/hooks/useModalsOpen';
import {getQueryParams} from '@/utils/common';
import {DEFAULT_SEARCH_PARAMS} from '@/constants/search';
import {getCategoryProductsByIdThunk, selectCurrentPage,} from '@/store/reducers/pages/catalog/catalog';
import {useTypedSelector} from '@/store/store';
import {QUERY_DEFAULT_VALUES} from '@/constants/catalog';

type Props = {
  alias: string;
  productId: number;
};

const SortBtn = ({alias, productId}: Props) => {

  const t = useTranslations();
  const OPTIONS = getOptions(t);
  
  const [selectedOption, setSelectedOption] = useState<Option>(OPTIONS[0]);
  const dispatch = useDispatch();
  const router = useRouter();
  const openModal = useModal();
  const {openModalState} = useModalsOpen();
  const sortParam = getQueryParams()?.[DEFAULT_SEARCH_PARAMS.SORT];
  const currentPage = useTypedSelector(selectCurrentPage);

  const onChange = (option: Option) => {
    const params: QueryParams = {
      ...getQueryParams(),
      [DEFAULT_SEARCH_PARAMS.PAGE_LIMIT]: QUERY_DEFAULT_VALUES.PageLimit,
      [DEFAULT_SEARCH_PARAMS.PAGE_OFF_SET]:
      QUERY_DEFAULT_VALUES.PageLimit * (currentPage - 1),
    };

    if (params[DEFAULT_SEARCH_PARAMS.SORT] === option.value) {
      return null;
    }

    params[DEFAULT_SEARCH_PARAMS.SORT] = option.value;
    router.replace(
      {
        query: {
          ...router.query,
          ...{[DEFAULT_SEARCH_PARAMS.SORT]: option.value},
        },
      },
      undefined,
      {
        shallow: true,
      }
    );
    setSelectedOption(option);
    dispatch(getCategoryProductsByIdThunk(alias, productId, params));
  };

  useEffect(() => {
    const currentSortOption = OPTIONS.find(
      (option) => option.value === sortParam
    );
    if (currentSortOption) {
      setSelectedOption(currentSortOption);
    }
  }, [sortParam]);

  const openSort = () => {
    openModalState();
    openModal(
      MultiSelect,
      {
        options: OPTIONS,
        onChange,
        value: selectedOption,
        alias,
      },
      {
        withAnimation: false,
      }
    );
  };

  return (
    <Component onClick={openSort}>
      <Icon>
        <SortIcon/>
      </Icon>
      <Title>{t('sort.name')}</Title>
    </Component>
  );
};

const Component = styled.div`
  &:hover {
  }

  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;

  border: 1px solid #860935;
  box-sizing: border-box;
  border-radius: 5px;
`;

const Icon = styled.span`
  line-height: 0;
`;

const Title = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  text-align: center;
  color: #870a36;

  margin-left: 9px;
`;

export default SortBtn;
